module.exports = __webpack_public_path__ + "img/software-development.847451b1.svg";